<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3 style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;"
        >{{ table_title }}</h3>
      </Col>
    </Row>
    </br>
    <Row>
      <Col span="20">
        <v-table
          :title="this.final_interface_record_title"
          :title_info="this.final_interface_record_info"
          :table_columns="this.final_interface_record_table_columns"
          :table_data="this.final_interface_record_table_data"
          :ref="this.final_interface_record_ref"
          :max_height="700"
          :init_table="this.final_interface_record_init_table_func"
          :table_name_array="this.final_interface_name_array"
          :show_top="false"
          :show_page="true"
          :table_page_size="50"
          :selection_change="this.selection_change"
        ></v-table>
        </Col>
        <Col span="4">
          <Row style="height:10px;"></Row>
            <Row>
              <Col offset="1" span="20">
              <Button type="error" size="large" long @click="open_modal(0)">紧急平仓接口</Button>
              </Col>
            </Row>
            <Row style="height:20px;"></Row>
            <Row>
              <Col offset="1" span="20">
              <Button type="success" size="large" long @click="open_modal(1)">关闭前端接口</Button>
              </Col>
            </Row>
        </Col>
      </Col>
      <Modal
        v-model="select_final_interface"
        title="杀死选中的策略进程, 撤销所有订单并平掉所有仓位"
        @on-ok="select_final_interface_ok"
        ok-text="发送"
        loading
      >
        <p slot="header" class="demo-drawer-hearde">
          <Icon type="information-circled"></Icon>
          <span><b>杀死选中的策略进程,撤销所有订单,平掉所有仓位</b></span>
        </p>
        <Row type="flex" justify="start">
          <Form label-position="left" :label-width="120" :label-colon="true">
            <FormItem label="勾选数量">
              <i-input
                v-model="select_final_interface_total_num"
                readonly
              >
              </i-input>
            </FormItem>
            <FormItem label="账户编号">
              <i-input
                v-model="select_final_interface_acc_id_list"
                readonly
              >
              </i-input>
            </FormItem>
            <FormItem label="二次验证码">
              <i-input
                v-model="select_final_interface_auth_code"
                clearable
                maxlength=10
              >
              </i-input>
            </FormItem>
            <FormItem label="申请邮箱发送">
              <Button
                icon="ios-color-wand-outline"
                @click="email_set_ok"
                :loading="this.email_button_loading"
              ><a>申请</a>
              </Button>
            </FormItem>
          </Form>
        </Row>
      </Modal>
      <Modal
        v-model="select_close_web"
        title="紧急关闭前端"
        @on-ok="select_close_web_ok"
        ok-text="发送"
        loading
      >
        <p slot="header" class="demo-drawer-hearde">
          <Icon type="information-circled"></Icon>
          <span><b>紧急关闭前端</b></span>
        </p>
        <Row type="flex" justify="start">
          <Form label-position="left" :label-width="120" :label-colon="true">
            <FormItem label="二次验证码">
              <i-input
                v-model="select_close_web_auth_code"
                clearable
                maxlength=10
              >
              </i-input>
            </FormItem>
          </Form>
        </Row>
      </Modal>
    </Row>
  </div>
</template>

<script>
import table_view from "../components/TableView.vue";

export default {
  name: "tools_finalInterface",
  components: {
    "v-table": table_view,
  },
  data() {
    return {
      timer: null,
      split_percent: 0.85,
      table_title:"紧急接口, 极端情况时使用",
      
      select_final_interface:false,
      select_final_interface_acc_id_list:null,
      select_final_interface_total_num:null,
      select_final_interface_auth_code:null,
      email_button_loading:false,

      select_close_web:false,
      select_close_web_auth_code:null,

      final_interface_record_title: "",
      final_interface_record_info: [],
      final_interface_record_table_columns: [],
      final_interface_record_table_data: [],
      final_interface_record_ref: "final_interface_record_ref",
      final_interface_name_array: [
        "账户编号",
        "邮箱",
        "描述信息",
        "执行标的",
        "账户权益-USDT",
        "账户权益-BTC",
        "当前杠杆",
        "当前运行策略信息",
      ],
      final_interface_show_slider: [],
      final_interface_selection:[],
    };
  },
  watch: {
    select_final_interface(old_value) {
        if (this.select_final_interface == false) {
            return null
        }
      this.report_warning(3)
      this.select_final_interface_auth_code = null
      this.select_final_interface_total_num = this.final_interface_selection.length
      var acc_id_list = ""
      for (var i = 0;i<this.final_interface_selection.length;i++) {
          acc_id_list += this.final_interface_selection[i]["账户编号"] + ","
      }
      acc_id_list = acc_id_list.substr(0, acc_id_list.length - 1);
      this.select_final_interface_acc_id_list = acc_id_list
    },
    select_close_web(old_value) {
        if (this.select_close_web == false) {
            return null
        }
      this.report_warning(0)
      this.select_close_web_auth_code = null
    },
  },
  methods: {
    email_set_ok: async function() {
        this.email_button_loading = true;
        const formData = new FormData();
        formData.append("mode", "email_report_code");
        let data = await this.$axios({
          url: this.$store.state.urlPort + "/final_interface",
          method: "post",
          data: formData,
        });
        this.$Message.info(data);
        this.email_button_loading = false
    },
    report_warning: async function(mode) {
        // 向后台发送报警
        // mode==3:打开了紧急平仓接口
        // mode==0:打开了关闭前端接口
        const formData = new FormData();
        formData.append("mode", "report_warning");
        formData.append("data", JSON.stringify({
          "mode": mode,
        }));
        await this.$axios({
          url: this.$store.state.urlPort + "/final_interface",
          method: "post",
          data: formData,
        });
    },
    selection_change: function(selection) {
        this.final_interface_selection = selection
    },
    select_final_interface_ok:async function() {
      //用户单击了紧急平仓按钮
      const formData = new FormData();
      formData.append("mode", "final_interface");
      formData.append("data", JSON.stringify({
        "code": this.select_final_interface_auth_code,
        "acc_id_list": this.select_final_interface_acc_id_list
      }));
      let data = await this.$axios({
        url: this.$store.state.urlPort + "/final_interface",
        method: "post",
        data: formData,
      });
      this.$Message.info(data);
      this.select_final_interface = false;
    },
    select_close_web_ok:async function() {
      //用户单击了关闭前端按钮
      const formData = new FormData();
      formData.append("mode", "close_web");
      formData.append("data", JSON.stringify({
        "code": this.select_close_web_auth_code,
      }));
      let data = await this.$axios({
        url: this.$store.state.urlPort + "/final_interface",
        method: "post",
        data: formData,
      });
      this.$Message.info(data);
      this.select_close_web = false;
    },
    setTimer: function (interval) {
      // if (this.timer == null) {
      //   this.timer = setInterval(() => {
      //     this.load_tables_data_set();
      //   }, interval);
      // }
    },
    load_tables_data_set: async function () {
      let final_interface_record_table_data = await this.$axios.get(
        this.$store.state.urlPort + "/final_interface",
        {
          params: {
            mode: "get_table_msg",
          },
        }
      );
      this.set_final_interface_record_data(final_interface_record_table_data);
    },
    set_final_interface_record_data: function (data) {
      this.final_interface_record_title = data["name"];
      this.final_interface_record_table_data = [];
      for (var i = 0; i < data["data"].length; i++) {
        this.final_interface_record_table_data.push(data["data"][i]);
      }
    },
    final_interface_record_init_table_func: function () {
      const name_array = this.final_interface_name_array;
      this.final_interface_record_table_columns = [{type: 'selection', align: 'center'}];
      for (var i = 0; i < name_array.length; i++) {
        this.final_interface_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center",
        });
      }
      this.final_interface_record_table_columns[0]["Width"] = 15;
      this.final_interface_record_table_columns[1]["Width"] = 15;
      this.final_interface_record_table_columns[2]["minWidth"] = 80;
      this.final_interface_record_table_columns[2]["tooltip"] = true;
      this.final_interface_record_table_columns[3]["minWidth"] = 120;
      this.final_interface_record_table_columns[3]["tooltip"] = true;
      
      this.final_interface_record_table_columns[4]["minWidth"] = 50;
      this.final_interface_record_table_columns[5]["minWidth"] = 50;
      this.final_interface_record_table_columns[6]["minWidth"] = 50;

      //this.final_interface_record_table_columns[8]["type"] = "html";
      this.final_interface_record_table_columns[8]["minWidth"] = 155;
      this.final_interface_record_table_columns[8]["tooltip"] = true;
      
    },
    open_modal: function (mode) {
        if (mode == 0) {
            this.select_final_interface = true
        }
        else {
            this.select_close_web = true
        }
    },
  },
  mounted() {
    this.account_id = this.$route.path.split("=")[1];
    this.load_tables_data_set();
  },
  created: function () {
    clearInterval(this.timer);
    this.timer = null;
    // 刷新频率
    this.setTimer(10 * 1000);
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color: #2b85e4;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.demo-drawer-hearde {
  width: 100%;

  text-align: center;
  background: #fff;
}
</style>